export default {
    setViewTree(state, tree) {
        state.viewTree = tree;
    },
}

